import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store';
import { setActiveLocation } from '@/store/uiSlice';
import { useGetLocationsQuery } from '@/store/api';

/**
 * Every configuration screen is scoped to one location. This keeps the choice
 * in one place and defaults to the first location so single-site restaurants
 * never see a picker they do not need.
 */
export function useActiveLocation() {
  const dispatch = useAppDispatch();
  const activeLocationId = useAppSelector((state) => state.ui.activeLocationId);
  const { data, isLoading } = useGetLocationsQuery();

  const locations = data?.data ?? [];

  useEffect(() => {
    const first = locations[0]?._id;
    const stillExists = locations.some((location) => location._id === activeLocationId);
    if (first && !stillExists) dispatch(setActiveLocation(first));
  }, [locations, activeLocationId, dispatch]);

  return {
    locationId: activeLocationId ?? locations[0]?._id ?? '',
    locations,
    isLoading,
    setLocation: (id: string) => dispatch(setActiveLocation(id))
  };
}
